import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import CustomInput from '../components/CustomInput';
import CustomDropDown from '../components/CustomDropDown';
import contactForm from '../services/contactForm';
import CheckoutFormComplete from '../components/CheckoutFormComplete';
import WhatImg from '../assets/images/what_is_right.svg';
import fetchStatesDropdownOptions from '../services/states';
import OrderFail from '../components/OrderFail';
import industries from '../utils/industries';

import './checkoutForm.scss';

function CheckoutForm() {
  const [loadingSubmitedForm, setLoadingSubmitedForm] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [USStatesDropdownOptions, setUSStatesDropdownOptions] = useState([]);

  useEffect(async () => {
    const options = await fetchStatesDropdownOptions();
    setUSStatesDropdownOptions(options);
  }, []);

  const [submissionError, setSubmissionError] = useState('');
  const [formErrors, setformErrors] = useState({});
  const [form, setForm] = useState({
    businessName: '',
    numberOfLocations: '',
    numberOfDevices: '',
    industry: '',
    businessAddress: '',
    businessAddress2: '',
    city: '',
    state: '',
    zipCode: '',
    businessOutsideUS: 'United States',
    firstName: '',
    lastName: '',
    businessEmail: '',
    businessEmailConfirmation: '',
    phone: '',
    role: '',
    agree: true,
  });

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setformErrors({ ...formErrors, [e.target.name]: null });
    setSubmissionError('');
  };

  const handleDropdownChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setformErrors({ ...formErrors, [e.target.name]: null });
    setSubmissionError('');
  };

  const validateForm = () => {
    const errors = {
      ...formErrors,
      businessName: !form.businessName ? 'This information is required' : null,
      numberOfLocations: !form.numberOfLocations ? 'This information is required' : null,
      numberOfDevices: !form.numberOfDevices ? 'This information is required' : null,
      industry: !form.industry ? 'This information is required' : null,
      businessAddress: !form.businessAddress ? 'This information is required' : null,
      city: !form.city ? 'This information is required' : null,
      state: !form.state ? 'This information is required' : null,
      zipCode: !form.zipCode ? 'This information is required' : null,
      businessOutsideUS: !form.businessOutsideUS ? 'This information is required' : null,
      firstName: !form.firstName ? 'This information is required' : null,
      lastName: !form.lastName ? 'This information is required' : null,
      businessEmail: !form.businessEmail ? 'This information is required' : null,
      businessEmailConfirmation: !form.businessEmailConfirmation ? 'This information is required' : null,
      phone: !form.phone ? 'This information is required' : null,
      role: !form.role ? 'This information is required' : null,
    };
    setformErrors(errors);

    return !Object.values(errors).includes('This information is required');
  };

  const numberOfLocations = [
    {
      label: '1',
      value: '3',
    },
    {
      label: '2-9',
      value: '9',
    },
    {
      label: '10-24',
      value: '24',
    },
    {
      label: '25+',
      value: '25',
    },
  ];

  const numberOfDevices = [
    {
      label: '1',
      value: '1',
    },
    {
      label: '2',
      value: '2',
    },
    {
      label: '3',
      value: '3',
    },
    {
      label: 'unsure',
      value: 'unsure',
    },
  ];

  const submit = async () => {
    if (validateForm()) {
      setLoadingSubmitedForm(true);
      const result = await contactForm(form);
      if (result.status === 200) {
        setShowSuccessMessage(true);
        setSubmissionError(null);
      } else {
        const { response } = result;
        const error = response ? response.data : 'An error occurred, please try again later';
        setSubmissionError(error);
      }
      setLoadingSubmitedForm(false);
    }
  };

  return loadingSubmitedForm ? (
    <div className="flex justify-content-center align-items-center" style={{ width: '100%', height: '100vh' }}>
      <div className="flex align-self-center justify-content-center">
        <i className="pi pi-spin pi-spinner" style={{ fontSize: '4em', color: '#da39ff' }} />
      </div>
    </div>
  ) : (
    <div id="checkoutForm">
      {showSuccessMessage ? (
        <div>
          <CheckoutFormComplete />
        </div>
      ) : null}
      {submissionError && <OrderFail detail={submissionError} />}
      {!showSuccessMessage && (
        <div className="grid">
          <div className="grid main_container_box">
            <div className="data_container col-7">
              <div className="grid">
                <div className="col-12 flex align-items-center header padding_0 mb-4">
                  <div className="header_text_box">
                    <h2 className="header_title">Contact Form</h2>
                  </div>
                </div>
                <div className="form_conatiner">
                  <div className="under-title-box">
                    <p className="under-title">
                      Please complete the information below and a UPshow Implementation Specialist will be in touch shortly
                    </p>
                  </div>
                  <div className="col-12 sub-header">
                    <h3>Business Information</h3>
                  </div>
                  <div className="col-12">
                    <div className="field title-input">
                      <label className="block label required_icon" htmlFor="businessName">
                        Business Name
                      </label>
                      <CustomInput
                        value={form.businessName}
                        onChange={handleChange}
                        name="businessName"
                        type="text"
                        placeholder="Business Name..."
                        error={formErrors.businessName}
                        errorMessage={formErrors.businessName}
                      />
                    </div>
                  </div>
                  <div className="inputs_box flex">
                    <div className="col-6 title-input">
                      <label className="block label required_icon" htmlFor="numberOfLocations">
                        Number of locations
                      </label>
                      <CustomDropDown
                        value={form.numberOfLocations}
                        options={numberOfLocations}
                        onChange={handleDropdownChange}
                        placeholder="Number of locations"
                        name="numberOfLocations"
                        error={formErrors.numberOfLocations}
                        errorMessage={formErrors.numberOfLocations}
                      />
                    </div>
                    <div className="col-6 title-input">
                      <label className="block label required_icon" htmlFor="numberOfDevices">
                        Devices per Location
                      </label>
                      <CustomDropDown
                        value={form.numberOfDevices}
                        options={numberOfDevices}
                        onChange={handleDropdownChange}
                        placeholder="Number of devices"
                        name="numberOfDevices"
                        error={formErrors.numberOfDevices}
                        errorMessage={formErrors.numberOfDevices}
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="field title-input">
                      <label className="block label required_icon" htmlFor="industry">
                        Industry
                      </label>
                      <CustomDropDown
                        value={form.industry}
                        options={industries}
                        onChange={handleDropdownChange}
                        placeholder="Industry"
                        name="industry"
                        error={formErrors.industry}
                        errorMessage={formErrors.industry}
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="field title-input">
                      <label className="block label required_icon" htmlFor="businessAddress">
                        Business Address Line 1
                      </label>
                      <CustomInput
                        value={form.businessAddress}
                        onChange={handleChange}
                        name="businessAddress"
                        type="text"
                        placeholder="Business Address..."
                        error={formErrors.businessAddress}
                        errorMessage={formErrors.businessAddress}
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="field title-input">
                      <label className="block label required_icon" htmlFor="businessAddress2">
                        Business Address Line 2
                      </label>
                      <CustomInput
                        value={form.businessAddress2}
                        onChange={handleChange}
                        name="businessAddress2"
                        type="text"
                        placeholder="Business Address..."
                        error={formErrors.businessAddress2}
                        errorMessage={formErrors.businessAddress2}
                      />
                    </div>
                  </div>
                  <div className="flex inputs_box col-12 padding_0">
                    <div className="flex left_box col-6 padding_0">
                      <div className="col-6">
                        <div className="p-field title-input">
                          <label className="block label required_icon" htmlFor="city">
                            City
                          </label>
                          <CustomInput
                            value={form.city}
                            onChange={handleChange}
                            name="city"
                            type="text"
                            placeholder="City..."
                            error={formErrors.city}
                            errorMessage={formErrors.city}
                          />
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="field title-input">
                          <label className="block label required_icon" htmlFor="zipCode">
                            Zip code
                          </label>
                          <CustomInput
                            value={form.zipCode}
                            onChange={handleChange}
                            name="zipCode"
                            type="text"
                            placeholder="Zip Code..."
                            error={formErrors.zipCode}
                            errorMessage={formErrors.zipCode}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="field title-input">
                        <label className="block label required_icon" htmlFor="state">
                          State / Province
                        </label>
                        <CustomDropDown
                          value={form.state}
                          options={USStatesDropdownOptions}
                          onChange={handleDropdownChange}
                          placeholder={USStatesDropdownOptions.length === 0 ? 'Loading' : 'State / Province...'}
                          name="state"
                          error={formErrors.state}
                          errorMessage={formErrors.state}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 mb-6">
                    <div className="field title-input">
                      <label className="block label" htmlFor="businessOutsideUS">
                        Country
                      </label>
                      <CustomInput
                        value={form.businessOutsideUS}
                        onChange={handleDropdownChange}
                        name="businessOutsideUS"
                        placeholder="Country..."
                        disabled
                      />
                      <div className="col-12 paraf padding_0">
                        <p>
                          <b>Note: </b>If you live outside of the United States, please contact our&nbsp;
                          <a href="https://www.upshow.tv/get-a-demo/" target="_blank" rel="noopener noreferrer">
                            Customer Success
                          </a>
                          &nbsp;team so we can get you set up
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 sub-header">
                    <h3>Personal Information</h3>
                  </div>
                  <div className="inputs_box flex">
                    <div className="col-6 ">
                      <div className="field title-input">
                        <label className="block label required_icon" htmlFor="firstName">
                          First Name
                        </label>
                        <CustomInput
                          value={form.firstName}
                          onChange={handleChange}
                          name="firstName"
                          type="text"
                          placeholder="First Name..."
                          error={formErrors.firstName}
                          errorMessage={formErrors.firstName}
                        />
                      </div>
                    </div>
                    <div className="col-6 ">
                      <div className="field title-input">
                        <label className="block label required_icon" htmlFor="lastName">
                          Last Name
                        </label>
                        <CustomInput
                          value={form.lastName}
                          onChange={handleChange}
                          name="lastName"
                          type="text"
                          placeholder="Last Name..."
                          error={formErrors.lastName}
                          errorMessage={formErrors.lastName}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="inputs_box flex">
                    <div className="col-6 ">
                      <div className="field title-input">
                        <label className="block label required_icon" htmlFor="businessEmail">
                          Email
                        </label>
                        <CustomInput
                          value={form.businessEmail}
                          onChange={handleChange}
                          name="businessEmail"
                          type="text"
                          placeholder="example@example.com"
                          error={formErrors.businessEmail}
                          errorMessage={formErrors.businessEmail}
                        />
                      </div>
                    </div>
                    <div className="col-6 ">
                      <div className="field title-input">
                        <label className="block label required_icon" htmlFor="businessEmailConfirmation">
                          Confirm Email
                        </label>
                        <CustomInput
                          value={form.businessEmailConfirmation}
                          onChange={handleChange}
                          name="businessEmailConfirmation"
                          type="text"
                          placeholder="example@example.com"
                          error={formErrors.businessEmailConfirmation}
                          errorMessage={formErrors.businessEmailConfirmation}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="field title-input">
                      <label className="block label required_icon" htmlFor="phone">
                        Phone Number
                      </label>
                      <CustomInput
                        value={form.phone}
                        onChange={handleChange}
                        name="phone"
                        type="text"
                        placeholder="Phone Number..."
                        error={formErrors.phone}
                        errorMessage={formErrors.phone}
                      />
                    </div>
                  </div>
                  <div className="col-12 mb-6">
                    <div className="field title-input">
                      <label className="block label required_icon" htmlFor="role">
                        Title
                      </label>
                      <CustomInput
                        value={form.role}
                        onChange={handleChange}
                        name="role"
                        type="text"
                        placeholder="Title..."
                        error={formErrors.role}
                        errorMessage={formErrors.role}
                      />
                    </div>
                  </div>

                  <div className="button_box flex justify-content-end">
                    <Button onClick={submit} type="submit" label="Submit" />
                  </div>
                </div>
              </div>
            </div>
            <div className="img_box col-5">
              <img className="what_img" src={WhatImg} alt="box" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CheckoutForm;
